const EntityRoot = require('./root')

class EntityBase extends EntityRoot {
  constructor(document) {
    super(document)
    this.DateCreation = document.DateCreation || new Date()
  }
}

module.exports = EntityBase
